import { defineStore } from "pinia";
import { computed, ref } from "vue";
import type { Brand, Engine, ManualVehicle, Model, VehicleSearchResult } from "@/types";
import local from '@/stores/local'
import axios from "axios";
import { useMessageStore } from "./messageStore";

export const useVehicleStore = defineStore('vehicle', () => {
  const message = useMessageStore()

  const isManualInput = ref(false)
  const details = ref<VehicleSearchResult>()
  const manualVehicle = ref<Partial<ManualVehicle>>({})
  const mileage = ref<number>()
  const age = computed(() => {
    return details.value?.registrationYear ? new Date().getFullYear() - details.value.registrationYear : undefined
  })
  const brandName = computed(() => details.value?.brand ?? manualVehicle.value.brand?.name)

  const registrationLabel = computed<string>(() => {
    if (!details.value?.registrationYear) {
      return ''
    }
    else if (!details.value.registrationMonth) {
      return details.value.registrationYear.toString()
    }
    else {
      return new Date(details.value.registrationYear, details.value.registrationMonth).toLocaleDateString('da-DK', { year: 'numeric', month: 'long' });
    }
  })

  async function search(licensePlate: string): Promise<VehicleSearchResult | undefined> {
    try {
      const { data } = await axios.get<VehicleSearchResult>(`proxy/vehicle/${licensePlate}`)

      local.setItem('vehicleSearchResult', data)
      return data
    } catch (error) {
      console.error(error)
      message.addError('Der opstod en fejl i søgningen på dit køretøj. Prøv at indtaste oplysningerne manuelt.')
    }
  }

  async function getSaved() {
    const vehicleSearchResult: VehicleSearchResult | null = await local.getItem('vehicleSearchResult')

    if (vehicleSearchResult) {
      details.value = vehicleSearchResult
    }

    else {
      const savedManualVehicle = await local.getItem<ManualVehicle>('manualVehicle')

      if (savedManualVehicle) {
        isManualInput.value = true
        manualVehicle.value = savedManualVehicle
      }
    }
  }

  function reset() {
    isManualInput.value = false
    details.value = undefined
    manualVehicle.value = {}
    mileage.value = undefined
  }

  return { isManualInput, details, manualVehicle, mileage, age, brandName, registrationLabel, search, reset, getSaved }
})